import { http, onSuccess, onFail } from './http';

export const getRecordProfiles = () =>
    http.get(`/api/cp/mediaStream/recordProfile`)
        .then(onSuccess, onFail);